import {
  Box,
  Divider,
  Heading,
  Hidden,
  Page,
  PageBlock,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';

import { SiteWideFooter } from 'src/components/SiteWideFooter';

const RenewListingSuccess = () => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <Box paddingTop="xlarge">
      <PageBlock width="small">
        <Stack space="xlarge">
          <Heading level="2" component="h1">
            Thanks, we&apos;ll be in touch soon
          </Heading>

          <Stack space="medium">
            <Stack space="small">
              <Text>
                <Strong>Renewal: Business Listing</Strong>
              </Text>

              <Text>
                Thanks for getting in touch about renewing your business
                listing. A member of our team will be in touch shortly to
                organise payment and activate your ad.
              </Text>
            </Stack>

            <Stack space="small">
              <Text>Thanks and speak soon,</Text>
              <Text>
                <Strong>The SEEK Business team</Strong>
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </PageBlock>
    </Box>
  </Page>
);

export default RenewListingSuccess;
